/*
  Advertorial behaviour tracker (horizontal fly page).
  Loaded only by layout/theme.advertorial.liquid. Builds one running summary per
  visit (time per section, scroll reach, clicks, backtracks) plus a capped list of
  click events, and posts it to the n8n "adv-visit" webhook at active-time
  checkpoints, on CTA clicks and when the page is hidden. n8n keeps the latest
  snapshot per visit, so every send is cumulative and retry-safe.

  Internal traffic: add ?dbaf_internal=1 once to flag this browser (=0 clears).
  Visits on preview/development themes, dev servers and myshopify.com are flagged too.
*/
(function () {
  'use strict';

  var cfg = window.dbafAnalyticsConfig || {};
  if (!cfg.endpoint || window.__dbafAnalytics) return;
  window.__dbafAnalytics = true;

  var BOT = /googlebot|bingbot|baiduspider|yandexbot|duckduckbot|slurp|facebot|facebookexternalhit|meta-externalads|meta-externalagent|ia_archiver|screaming frog|ahrefs|semrush|mj12bot|dataforseo|dotbot|petalbot|bytespider|headlesschrome|lighthouse|pagespeed|ptst|gtmetrix/i;
  if (navigator.webdriver || BOT.test(navigator.userAgent)) return;

  var TICK_MS = 500;
  var IDLE_MS = 30000;          // no input for 30s = not active (long reasons need time)
  var BACKTRACK_MS = 2000;      // must settle on an earlier section this long to count
  var MAX_EVENTS = 120;
  var CHECKPOINTS = [5, 15, 30, 60, 120];
  var CART_TAG_AFTER_MS = 10000;

  // --- Small helpers ---

  function getStore(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function setStore(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) { /* storage blocked */ }
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (e) { return ''; }
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function round1(ms) {
    return Math.round(ms / 100) / 10;
  }

  function toClarity() {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity.apply(window, arguments); } catch (e) { /* ignore */ }
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed() !== false;
      }
    } catch (e) { /* API not ready */ }
    return true;
  }

  // --- Visit context ---

  var params = new URLSearchParams(window.location.search);
  if (params.get('dbaf_internal') === '1') setStore('dbaf_internal', '1');
  if (params.get('dbaf_internal') === '0') setStore('dbaf_internal', null);

  var themeRole = window.Shopify && window.Shopify.theme ? window.Shopify.theme.role : 'main';
  var internal = getStore('dbaf_internal') === '1' ||
    params.has('preview_theme_id') ||
    (themeRole && themeRole !== 'main') ||
    /myshopify\.com$|^127\.|^localhost$/.test(window.location.hostname);

  // Reuse the A/B framework's visitor cookie so both datasets share an ID.
  var visitorId = getCookie('_ab_vid');
  if (!visitorId) {
    visitorId = uuid();
    document.cookie = '_ab_vid=' + visitorId + '; path=/; max-age=15552000; SameSite=Lax' +
      (window.location.protocol === 'https:' ? '; Secure' : '');
  }

  var visitId = uuid();
  var priorVisits = parseInt(getStore('dbaf_visits') || '0', 10) || 0;
  setStore('dbaf_visits', String(priorVisits + 1));

  var ua = navigator.userAgent;
  var isTablet = /iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua)) ||
    (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  var device = isTablet ? 'tablet' : (/Mobi|iPhone|Android/i.test(ua) ? 'mobile' : 'desktop');
  var inApp = /Instagram/i.test(ua) ? 'instagram' : (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'facebook' : '');

  var referrer = '';
  try { referrer = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) { /* ignore */ }

  var headlineAttr = document.documentElement.getAttribute('data-dbaf-headline');
  var headline = headlineAttr === 'story' || headlineAttr === 'press' ? headlineAttr : 'default';

  var utm = {};
  ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) {
    utm[key] = (params.get('utm_' + key) || '').slice(0, 150);
  });

  // --- Zones: a contiguous split of the page, in reading order ---
  // Each zone runs from its anchor's top to the next anchor's top, so headings
  // and padding between sections belong to the section above them.

  var zones = [];

  function words(el) {
    if (!el) return 0;
    var text = el.innerText || '';
    var found = text.match(/\S+/g);
    return found ? found.length : 0;
  }

  function buildZones() {
    var q = function (selector) { return document.querySelector(selector); };
    var reasons = document.querySelectorAll('.dbaf-reason');
    var reasonsHeading = q('#reasons');
    var bundle = q('.dbaf-bundle');
    var defs = [
      { key: 'press', anchor: q('.dbaf-press-band') },
      { key: 'intro', anchor: q('.dbaf-intro') },
      { key: 'story', anchor: q('.dbaf-story') },
      { key: 'how', anchor: q('section[aria-labelledby="how"]') },
      { key: 'r1', anchor: q('section[aria-labelledby="reasons"]'), text: [reasonsHeading, reasons[0]] }
    ];
    for (var i = 1; i < 7; i++) defs.push({ key: 'r' + (i + 1), anchor: reasons[i] });
    defs.push(
      { key: 'reviews', anchor: q('section[aria-labelledby="words"]') },
      { key: 'choose', anchor: q('#choose'), minus: bundle },
      { key: 'pricing', anchor: bundle },
      { key: 'guarantee', anchor: q('section[aria-labelledby="guarantee"]') },
      { key: 'ps', anchor: q('.dbaf-ps') },
      { key: 'footer', anchor: q('.dbaf-site-footer') }
    );

    defs.forEach(function (def) {
      if (!def.anchor) return;
      var count = def.text ? def.text.reduce(function (sum, el) { return sum + words(el); }, 0) : words(def.anchor);
      if (def.minus) count -= words(def.minus);
      zones.push({ key: def.key, anchor: def.anchor, words: Math.max(0, count), dwell: 0, reached: false, attended: false, index: zones.length });
    });
  }

  function zoneTops() {
    var tops = [];
    for (var i = 0; i < zones.length; i++) tops.push(zones[i].anchor.getBoundingClientRect().top);
    return tops;
  }

  // Index of the zone containing viewport-relative y.
  function zoneIndexAt(y, tops) {
    var found = 0;
    for (var i = 0; i < tops.length; i++) {
      if (tops[i] <= y) found = i;
      else break;
    }
    return found;
  }

  // --- Running state ---

  var startedAt = Date.now();
  var lastTick = startedAt;
  var lastInteraction = startedAt;
  var activeMs = 0;
  var visibleMs = 0;
  var maxScrollPct = 0;
  var firstScrollS = null;
  var currentZone = null;
  var furthestIndex = -1;
  var pendingBack = null;
  var counts = { clicks: 0, dead: 0, rage: 0, backtracks: 0, cta: 0, copies: 0 };
  var firstCta = '';
  var timeToCtaS = null;
  var events = [];
  var recentClicks = [];
  var rageUntil = 0;
  var cartTagged = false;
  var seq = 0;
  var lastSentSig = '';
  var checkpointIndex = 0;

  function secondsSinceStart() {
    return round1(Date.now() - startedAt);
  }

  function logEvent(kind, zoneKey, target, xPct, yPct) {
    if (events.length >= MAX_EVENTS) return;
    events.push({
      t: secondsSinceStart(),
      k: kind,
      z: zoneKey || '',
      g: String(target || '').slice(0, 80),
      x: xPct === undefined ? '' : xPct,
      y: yPct === undefined ? '' : yPct
    });
  }

  function markInteraction() {
    lastInteraction = Date.now();
  }

  // --- Measurement loop ---

  function measureScroll() {
    var doc = document.documentElement;
    var height = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (height <= 0) return;
    var pct = Math.min(100, Math.round(((window.scrollY + window.innerHeight) / height) * 100));
    if (pct > maxScrollPct) maxScrollPct = pct;
  }

  function onZoneChange(zone, now) {
    if (currentZone && zone.index < currentZone.index && zone.index < furthestIndex) {
      pendingBack = { to: zone, from: currentZone, since: now };
    } else {
      pendingBack = null;
    }
    currentZone = zone;
    if (zone.index > furthestIndex) furthestIndex = zone.index;
    if (!zone.attended) {
      zone.attended = true;
      toClarity('event', 'adv_zone_' + zone.key);
    }
  }

  function tick() {
    var now = Date.now();
    var dt = Math.min(now - lastTick, 2000);
    lastTick = now;
    if (document.visibilityState !== 'visible' || !zones.length) return;

    visibleMs += dt;
    var tops = zoneTops();
    for (var i = 0; i < zones.length; i++) {
      if (tops[i] < window.innerHeight) zones[i].reached = true;
    }
    measureScroll();

    if (now - lastInteraction > IDLE_MS) return;
    activeMs += dt;

    // Attention sits on the reading line, 40% down the viewport.
    var zone = zones[zoneIndexAt(window.innerHeight * 0.4, tops)];
    zone.dwell += dt;
    if (zone !== currentZone) {
      onZoneChange(zone, now);
    } else if (pendingBack && now - pendingBack.since >= BACKTRACK_MS) {
      counts.backtracks += 1;
      logEvent('backtrack', pendingBack.to.key, 'from ' + pendingBack.from.key);
      pendingBack = null;
    }

    if (!cartTagged && activeMs >= CART_TAG_AFTER_MS) tagCart();

    if (checkpointIndex < CHECKPOINTS.length) {
      if (activeMs >= CHECKPOINTS[checkpointIndex] * 1000) {
        checkpointIndex += 1;
        send('progress');
      }
    } else if (activeMs >= (CHECKPOINTS[CHECKPOINTS.length - 1] + 60 * (checkpointIndex - CHECKPOINTS.length + 1)) * 1000) {
      checkpointIndex += 1;
      send('progress');
    }
  }

  // --- Clicks ---

  function describe(el) {
    var tag = (el.tagName || '').toLowerCase();
    var node = el;
    while (node && node !== document.body) {
      var cls = typeof node.className === 'string' ? node.className.match(/dbaf-[a-z0-9_-]+/) : null;
      if (cls) return tag + '@' + cls[0];
      node = node.parentElement;
    }
    return tag;
  }

  function clickZone(viewY) {
    if (!zones.length) return { key: '', y: '' };
    var tops = zoneTops();
    var index = zoneIndexAt(viewY, tops);
    var top = tops[index];
    var bottom = index + 1 < tops.length ? tops[index + 1] : document.documentElement.scrollHeight - window.scrollY;
    var yPct = bottom > top ? Math.round(((viewY - top) / (bottom - top)) * 100) : '';
    return { key: zones[index].key, y: yPct };
  }

  function onClick(e) {
    markInteraction();
    var el = e.target;
    if (!el || !el.closest) return;

    var now = Date.now();
    var zone = clickZone(e.clientY);
    var xPct = window.innerWidth ? Math.round((e.clientX / window.innerWidth) * 100) : '';
    var kind;
    var target;

    var link = el.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var product = href.match(/\/products\/([^/?#]+)/);
      if (product) {
        kind = 'cta';
        target = product[1];
      } else {
        kind = 'link';
        target = href.charAt(0) === '#' ? href : (link.pathname || href);
      }
    } else if (el.closest('button, input, select, textarea, label, summary, video, [role="button"]')) {
      kind = 'click';
      target = describe(el);
    } else {
      kind = 'dead';
      target = describe(el);
    }

    // Rage: three or more taps within a second in roughly the same spot.
    recentClicks = recentClicks.filter(function (c) { return now - c.t < 1000; });
    recentClicks.push({ t: now, x: e.clientX, y: e.clientY });
    var near = recentClicks.filter(function (c) {
      return Math.abs(c.x - e.clientX) < 40 && Math.abs(c.y - e.clientY) < 40;
    });
    if (near.length >= 3 && now > rageUntil) {
      counts.rage += 1;
      rageUntil = now + 1500;
      logEvent('rage', zone.key, target, xPct, zone.y);
    }
    if (now < rageUntil && kind !== 'cta') return; // don't flood events during a burst

    counts.clicks += 1;
    if (kind === 'dead') counts.dead += 1;
    logEvent(kind, zone.key, target, xPct, zone.y);

    if (kind === 'cta') {
      counts.cta += 1;
      if (!firstCta) {
        firstCta = target + '@' + zone.key;
        timeToCtaS = secondsSinceStart();
      }
      toClarity('event', 'adv_cta_click');
      toClarity('set', 'adv_cta', target);
      tagCart();
      send('cta');
    }
  }

  // --- Order attribution: hidden cart attributes carried onto the order ---

  function tagCart() {
    if (cartTagged || !window.fetch) return;
    cartTagged = true;
    var attributes = {
      _adv_visit: visitId,
      _adv_headline: headline,
      _adv_source: utm.source,
      _adv_campaign: utm.campaign,
      _adv_ad: utm.content,
      _adv_at: new Date(startedAt).toISOString()
    };
    if (internal) attributes._adv_internal = '1';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
      keepalive: true
    }).catch(function () { cartTagged = false; });
  }

  // --- Sending ---

  function payload(reason) {
    var zoneData = {};
    zones.forEach(function (z) {
      zoneData[z.key] = [round1(z.dwell), z.words, z.reached ? 1 : 0];
    });
    return {
      v: 1,
      page: cfg.page || '',
      visit_id: visitId,
      visitor_id: visitorId,
      seq: seq,
      reason: reason,
      started_at: new Date(startedAt).toISOString(),
      headline: headline,
      utm: utm,
      fbclid: params.has('fbclid') ? 1 : 0,
      referrer: referrer,
      device: device,
      in_app: inApp,
      viewport: window.innerWidth + 'x' + window.innerHeight,
      returning: priorVisits > 0 ? 1 : 0,
      internal: internal ? 1 : 0,
      active_s: round1(activeMs),
      total_s: round1(visibleMs),
      max_scroll_pct: maxScrollPct,
      first_scroll_s: firstScrollS,
      furthest_zone: furthestIndex >= 0 ? zones[furthestIndex].key : '',
      exit_zone: currentZone ? currentZone.key : '',
      cta_clicks: counts.cta,
      first_cta: firstCta,
      time_to_cta_s: timeToCtaS,
      clicks: counts.clicks,
      dead_clicks: counts.dead,
      rage_clicks: counts.rage,
      backtracks: counts.backtracks,
      copies: counts.copies,
      zones: zoneData,
      events: events,
      ua: ua,
      url: window.location.href.slice(0, 500)
    };
  }

  function send(reason) {
    if (!zones.length || !analyticsAllowed()) return;
    var sig = [round1(activeMs), round1(visibleMs), events.length, maxScrollPct, currentZone ? currentZone.key : ''].join('|');
    if (sig === lastSentSig) return;
    lastSentSig = sig;
    seq += 1;

    var body = new URLSearchParams();
    body.set('p', JSON.stringify(payload(reason)));

    var queued = false;
    if (navigator.sendBeacon) {
      try { queued = navigator.sendBeacon(cfg.endpoint, body); } catch (e) { queued = false; }
    }
    if (!queued && window.fetch) {
      fetch(cfg.endpoint, { method: 'POST', body: body, mode: 'no-cors', credentials: 'omit', keepalive: true })
        .catch(function () { /* analytics only */ });
    }
  }

  // --- Wiring ---

  function start() {
    buildZones();
    if (!zones.length) return;

    toClarity('set', 'adv_headline', headline);
    toClarity('set', 'adv_visit', visitId);
    if (utm.content) toClarity('set', 'adv_ad', utm.content);
    if (utm.campaign) toClarity('set', 'adv_campaign', utm.campaign);
    if (internal) toClarity('set', 'adv_internal', '1');

    ['touchstart', 'touchmove', 'pointerdown', 'keydown', 'wheel', 'mousemove'].forEach(function (type) {
      window.addEventListener(type, markInteraction, { passive: true });
    });
    window.addEventListener('scroll', function () {
      markInteraction();
      if (firstScrollS === null && window.scrollY > 50) firstScrollS = secondsSinceStart();
    }, { passive: true });

    document.addEventListener('click', onClick, true);
    document.addEventListener('copy', function () {
      counts.copies += 1;
      logEvent('copy', currentZone ? currentZone.key : '', '');
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        send('hidden');
      } else {
        lastTick = Date.now();
        markInteraction();
      }
    });
    window.addEventListener('pagehide', function () { send('pagehide'); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        lastTick = Date.now();
        markInteraction();
      }
    });

    window.setInterval(tick, TICK_MS);
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
